export const validateProvince = (provInput: string): boolean =>
  ['NL', 'PE', 'NS', 'NB', 'QC', 'ON', 'MB', 'SK', 'AB', 'BC', 'YT', 'NT', 'NU'].some(
    prov => prov === provInput.toUpperCase()
  )
